module.exports = __webpack_public_path__ + "static/media/strategy.61300961.png";